import React, { useCallback, useState } from 'react'
import ReactModal from 'react-modal'
import GenericErrorModal from 'components/VirtualPortal/components/ErrorModal'

const EvaluationModal = ({
  toggleModal, 
  isOpen,
  session, 
  sessionType,
  setNewState
}) => {
  const [ state, setState ] = useState({
    sessionType,
    commentText: '',
    overallRating: 0,
    errorModalIsOpen: false,
    errorMessage: null,
    errorStatus: null
  })

  const submitButtonStatus = (state.overallRating === undefined || state.overallRating === 0) ? 'disabled' : ''

  const star = useCallback((overallRating) => setState({ ...state, overallRating }),[state])

  const updateComment = useCallback((e) => setState({...state, commentText: e.target.value}), [state])

  const handleCloseGenericErrorModal = useCallback(() => {
    setState({...state,  errorModalIsOpen: false})
    toggleModal()
  },[state, toggleModal])

  const submit = useCallback(() => {
    let url, data
    if(state.sessionType == 'meeting'){
      url = '/virtual_portal/event_one_on_one_meeting_survey'
      data = {
        event_one_on_one_meeting_survey: {
          event_one_on_one_meeting_id: session.event_one_on_one_meeting?.id,
          rating: state.overallRating,
          comments: state.commentText,
        }
      }
    } else {
      url = '/virtual_portal/event_session_surveys'
      data = {
        event_session_survey: {
          event_session_id: session.id,
          rating: state.overallRating,
          comments: state.commentText
        }
      }
    }
    window.api.post(url, data).then(() => {
      toggleModal(false, { evaluationCompleted: true })
    }).catch((error) => {
      if (error.response.status == 422) {
        setState({
          ...state,
          errorModalIsOpen: true,
          errorStatus: 'This session has not yet started',
          errorMessage: error.response.data.errors
        })
        return
      } else {
        setState({
          ...state,
          errorModalIsOpen: true,
          errorStatus: error.response.status,
          errorMessage: error.message
        })
        return
      }
    })
  },[setNewState, toggleModal, state])

  return(
    <ReactModal
      className="react-modal evaluation-modal"
      onRequestClose={toggleModal}
      isOpen={ isOpen }
      appElement={ document.querySelector('#root') }
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
      <div className='header'>
        <h3>{session.name}</h3>
        <i className='fa fa-times-thin fa-2x' onClick={toggleModal}></i>
      </div>
      <div className="evaluation-modal-content">
        <p>How would you rate this {state.sessionType}?</p>
        <div className="evaluation-modal-stars">
          <i onClick={() => star(1)} className={(state.overallRating >= 1 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => star(2)} className={(state.overallRating >= 2 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => star(3)} className={(state.overallRating >= 3 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => star(4)} className={(state.overallRating >= 4 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
          <i onClick={() => star(5)} className={(state.overallRating >= 5 ? 'fa fa-star checked' : 'fa fa-star-o unchecked')}></i>
        </div>
        <textarea className="form-control" placeholder="Additional Comments ..." value={state.commentText} onChange={updateComment} />
        <hr/>
        <div className="button-container">
          <button className='btn btn-primary' disabled={submitButtonStatus} onClick={submit}>Submit</button>
        </div>
        {state.errorModalIsOpen &&
          <GenericErrorModal
            toggleModal={handleCloseGenericErrorModal}
            isOpen={state.errorModalIsOpen}
          >
            <h5>{state?.errorStatus}</h5>
            <hr/>
            <h6>{state?.errorMessage}</h6>
          </GenericErrorModal>
        }
      </div>
    </ReactModal>
  )

}

export default EvaluationModal